import styled from '@emotion/styled';

export const MainPageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;
